// File: src/api/config.js
export const API_BASE = (
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : "https://social.buildstart.au"
) + "/api";

// Token source can be swapped to cookies or a context provider later
export function getAuthToken() {
  const lsToken = localStorage.getItem("token") || localStorage.getItem("authToken") || "";
  if (lsToken) return lsToken;
  const m = document.cookie.match(/(?:^|; )token=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}

// Copies a readable cookie token into localStorage for faster subsequent requests
export function syncCookieTokenToLocalStorage() {
  if (localStorage.getItem("token")) return;
  const m = document.cookie.match(/(?:^|; )token=([^;]+)/);
  if (m) {
    try { localStorage.setItem("token", decodeURIComponent(m[1])); } catch {}
  }
}

// Optional: read token from URL fragment (SSO bridge) then clear it from the URL
export function absorbHashToken() {
  if (window.location.hash && window.location.hash.startsWith("#token=")) {
    const token = decodeURIComponent(window.location.hash.slice(7));
    if (token) {
      try { localStorage.setItem("token", token); } catch {}
      // Clear the hash to avoid leaking via copy/paste
      window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }
  }
}